import { createContext } from "react";

const MilaContext = createContext();

export default MilaContext;